import React from 'react';

const DateButton = ({ onClick }) => {
  return (
    <button
      className="fab date-button"
      onClick={onClick}
      title="Selecionar Data"
      aria-label="Abrir seletor de data"
    >
      📅
    </button>
  );
};

export default DateButton;

